<template>
    <div v-if="open" class="rc-overlay" @click="onOverlayClick">
      <div class="rc-modal" @click.stop>
        <result-modal
          :status="payload.status"
          :title="resolvedTitle"
          :message="resolvedMessage"
          :actions="payload.actions || defaultActions"
          :closable="payload.closable !== false"
          @close="$emit('close')"
          @action="$emit('action', $event)"
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResultModalOverlay',
    props: {
      open: Boolean,
      payload: { type: Object, default: null },
      i18n: { type: Object, required: true },
    },
    computed: {
      resolvedTitle() {
        const p = this.payload || {};
        const fallback = this.i18n.t(`resultTitle.${p.status || 'neutral'}`);
        return p.title || fallback;
      },
      resolvedMessage() {
        const p = this.payload || {};
        if (!p.message) return '';
        return this.i18n.te(p.message)
          ? this.i18n.t(p.message, p.messageParams || {})
          : p.message;
      },
      defaultActions() {
        const status = this.payload?.status || 'neutral';
        if (status === 'danger' || status === 'warning') {
          return [
            { label: this.i18n.t('cancel'), key: 'cancel', variant: 'outline' },
            { label: this.i18n.t('ok'), key: 'ok', variant: 'solid' },
          ];
        }
        return [{ label: this.i18n.t('ok'), key: 'ok', variant: 'solid' }];
      },
    },
    methods: {
      onOverlayClick() {
        const closable = this.payload?.closable !== false;
        if (closable) this.$emit('close');
      },
    },
  };
  </script>
  